import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
// @mui
import { Collapse } from '@mui/material';
// hooks
import useActiveLink from '../../../hooks/useActiveLink';
//
import NavItem from './NavItem';

// ----------------------------------------------------------------------

NavList.propTypes = {
  data: PropTypes.object,
  depth: PropTypes.number,
  hasChild: PropTypes.bool,
};

function descendantPathActive(children, pathname) {
  if (!children?.length) {
    return false;
  }
  return children.some((c) => {
    if (c.path && matchPath({ path: c.path, end: false }, pathname)) {
      return true;
    }
    return descendantPathActive(c.children, pathname);
  });
}

export default function NavList({ data, depth, hasChild }) {
  const { pathname } = useLocation();

  const { active, isExternalLink } = useActiveLink(data.path);

  const descendantActive = hasChild ? descendantPathActive(data.children, pathname) : false;
  const effectiveActive = active || descendantActive;

  const [open, setOpen] = useState(effectiveActive);

  useEffect(() => {
    if (effectiveActive) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [pathname, effectiveActive]);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={effectiveActive}
        isExternalLink={isExternalLink}
        onClick={handleToggle}
      />

      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.children} depth={depth} />
        </Collapse>
      )}
    </>
  );
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
  data: PropTypes.array,
  depth: PropTypes.number,
};

function NavSubList({ data, depth }) {
  return (
    <>
      {data.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={depth + 1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
}
